import React from 'react';
import SetPasswordService from '../../services/SetPasswordService';
import { ClientName } from '../../model/constants';

const SetPassword = () => {
    const setPasswordMutation = SetPasswordService();
    const setPassword = () => {
        const password = document.getElementById('password');
        setPasswordMutation.mutate({ password: password.value });
    };

    return (
      <div className="set-password">
        <div className="background" />
        <div className="panel">
          <div className="header">
            {`¡Bienvenido al configurador de ${ClientName}!`}
          </div>
          <div className="subheader">
            Introduce una nueva contraseña para continuar:
          </div>
          <div className="container-form">
            <form>
              <div className="password-title">CONTRASEÑA</div>
              <input
                className="password-value"
                type="text"
                id="password"
                placeholder=""
              />
            </form>
          </div>
          <div className="container-buttons">
            <button
              className="continue-button"
              type="button"
              onClick={() => setPassword()}
            ><span>Continuar</span>
            </button>
          </div>
        </div>
      </div>
);
};

export default SetPassword;
